import script from "./add-time-dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./add-time-dialog.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__